import PlusCircleSolidSVG from "@design-system/ui-icons/vanilla/PlusCircleSolid"
import { createIcon } from "../createIcon"

export const PlusCircleSolidIcon = createIcon(PlusCircleSolidSVG)
